import ToastHighLighter from '@/lib/ToastHighLighter';

export const PopoverCode = () => {
  const language = 'html';
  const codeString = `
// Popover
<button
  type="button"
  class="btn btn-primary"
  data-bs-toggle="popover"
  data-bs-placement="right | left | top | bottom"
  data-bs-trigger="hover focus"
  title="Popover title"
  data-bs-content="Content goes here ..."
>
  Popover content ...
</button>  
`;

  return (
    <>
      <ToastHighLighter
        name={'popover'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
